/* eslint-disable no-param-reassign */
import { Row } from 'common/types/scalarSpreadsheet';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { removeClassName } from 'utilities';
import { Change } from 'utilities/sanitizeCellValue/sanitizeCellValue';

const getOutdatedCellsChanges = ({ cell, rowConfig, cells }: {
  cell: ICell,
  rowConfig: Row[],
  cells: Record<string, ICell>,
}) => {
  const newChanges: Change<ICell>[] = [];

  rowConfig.forEach((_row, index) => {
    const { columnLegend } = cell;
    const rowNumber = index + 1;
    const key = columnLegend! + rowNumber;

    if (cells[key]) {
      const newCell = Object.assign(cells[key], {
        ...cells[key],
        className: removeClassName(cells[key].className ?? '', 'warning'),
        needs_actualization: false,
        action: null,
        extraActions: null,
      });

      newChanges.push({
        cell: newCell,
        value: cells[key].value as string,
      });
    }
  });

  return newChanges;
};

export default getOutdatedCellsChanges;
